import { render, staticRenderFns } from "./BookingCompletedWidget.vue?vue&type=template&id=156a44f7"
import script from "./BookingCompletedWidget.vue?vue&type=script&lang=js"
export * from "./BookingCompletedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports